import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { UserType } from 'domain/types';
import { useComponent } from 'hooks';
import { getCrbDispensaryStore } from 'stores/CrbDispensaryStore';
import { useUser } from 'tanstack-hooks';
import { Spinner } from 'ui';
import { userCanDoAction, userHasRole } from 'ui/routing/router-util';

export const CrbRoute: React.FC<{ path: string }> = useComponent(({ path }) => {
  let isDispensaryUser = false;
  let userHasRoles = false;
  let userHasAction = false;

  const { user } = useUser();
  const dispensaryStore = getCrbDispensaryStore();

  //check user type
  if (user?.id && user?.type === UserType.Dispensary) isDispensaryUser = true;

  //check user role and action
  if (user?.id && dispensaryStore.isLoaded && dispensaryStore.currentDispensary.groups) {
    userHasRoles = userHasRole(dispensaryStore.currentDispensary.groups, user, path);
    userHasAction = userCanDoAction(dispensaryStore.currentDispensary.groups, user, path);
  }

  return user?.marketing_user_in_progress || (isDispensaryUser && userHasRoles && userHasAction) ? (
    <Outlet />
  ) : !user?.id || !dispensaryStore.isLoaded || !dispensaryStore.currentDispensary.groups ? (
    <Spinner text="Loading business information..." />
  ) : !userHasRoles ? (
    <Navigate to={{ pathname: '/error' }} />
  ) : (
    <Navigate to={{ pathname: '/' }} />
  );
});
